import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    id: Number,
  }

  declare idValue: number

  connect(): void {
    const event = new CustomEvent('mismatch-row:ready', {
      bubbles: true,
      detail: { id: this.idValue },
    })
    document.dispatchEvent(event)
  }
}
